import {
  ModalContent,
  ModalFooter,
  ModalTitle,
  Button,
  TextRegular,
  GenericSelect
} from '@hm/fundamental'
import React, {useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'

import DivercityHandsImage from '../../assets/diversity-hands.svg'

import {usePersonas, useSelectPersona} from './usePersonas'

interface PersonalizeStepProps {
  closeModal: () => void
}

export const PersonalizeStep: React.FC<PersonalizeStepProps> = ({closeModal}) => {
  const {t} = useTranslation()
  const {personas} = usePersonas()
  const [selectedPersonaId, setSelectedPersonaId] = useState<number>()

  const {mutate: selectPersona} = useSelectPersona()

  const personasOptions =
    personas?.map((persona) => ({
      value: persona.id,
      label: t(`suite.personas.${persona.name}`, {defaultValue: persona.name})
    })) ?? []

  const handleSelectPersona = useCallback(() => {
    if (selectedPersonaId === undefined) {
      return
    }
    selectPersona(selectedPersonaId, {onSettled: closeModal})
  }, [selectedPersonaId, selectPersona, closeModal])

  const changeSelectedPersonaId = useCallback((value: string | number) => {
    setSelectedPersonaId(value as number)
  }, [])

  return (
    <>
      <div className="flex flex-row items-center justify-center w-full pb-6">
        <img src={DivercityHandsImage} alt="Personalize experience" className="max-w-xs" />
      </div>
      <ModalTitle>{t('suite.welcomeFlow.personalizeTitle')}</ModalTitle>
      <ModalContent className="flex flex-col items-center justify-center">
        <TextRegular>{t('suite.welcomeFlow.personalizeDescription')}</TextRegular>
        <div className="flex flex-row items-center justify-center w-full mt-4">
          <GenericSelect
            name="persona-select"
            label={t('suite.welcomeFlow.selectRole')}
            value={selectedPersonaId}
            setValue={changeSelectedPersonaId}
            values={personasOptions}
            defaultLabel={t('suite.welcomeFlow.selectRole')}
            data-cy="welcome_flow_persona_select"
          />
        </div>
      </ModalContent>
      <ModalFooter justifyClass="justify-center">
        <Button
          variant="primary"
          onClick={handleSelectPersona}
          data-cy="welcome_flow_personalize_button"
          disabled={selectedPersonaId === undefined}
        >
          {t('suite.welcomeFlow.discoverNewHProduce')}
        </Button>
      </ModalFooter>
    </>
  )
}
